import {Role} from "./oauth";
import type {AppDefinition} from "@/app";

export const AuthGuard = (app: AppDefinition, to: any) => {
  const auth = app.config.globalProperties.$auth;

  const fn = async () => {
    await auth.loadCredentials();

    // This should not let authenticated users access login and register pages
    if (!to.meta.roles && auth.isAuthenticated() && to.meta.anon) {
      return { name: "Groups" };
    }

    // No roles means no authentication required
    if (!to.meta.roles) {
      return;
    }

    // Not authenticated users are sent to login
    if (!auth.isAuthenticated()) {
      return {name: "Login", query: {"next": encodeURI(to.path)}};
    }

    if (auth.isMissingContactData() && to.name !== "UserProfileUpdate") {
      return {name: "UserProfileUpdate"};
    }

    if (!auth.isMissingContactData() && to.name === "UserProfileUpdate") {
      return {name: "Groups"};
    }

    // All authenticated users can pass if role ALL is specified
    if (to.meta.roles.includes(Role.ALL)) {
      return;
    }

    // Do role based check
    if (to.meta.roles.some((role: string) => auth.hasRole(role))) {
      return;
    }

    return {name: "Home"};
  };

  return fn();
};
